import request from '@/utils/request'
// 分类列表
export function fetchClassifyList(params) {
  return request({
    url: '/api/z/productCategory/list/withChildren',
    method: 'get',
    params: params
  })
}
// 分类列表
export function getClassifyList(parentId, params) {
  return request({
    url: '/productCategory/list/' + parentId,
    method: 'get',
    params: params
  })
}
// 添加分类
export function createClassify(data) {
  return request({
    url: '/productCategory/create',
    method: 'post',
    data: data
  })
}
// 获取分类
export function getClassify(id) {
  return request({
    url: '/productCategory/' + id,
    method: 'get',
  })
}
// 修改分类
export function updateClassify(id, data) {
  return request({
    url: '/productCategory/update/' + id,
    method: 'post',
    data: data
  })
}
// 删除分类
export function deleteClassify(id) {
  return request({
    url: '/productCategory/delete/' + id,
    method: 'post',
  })
}
// 修改显示状态
export function changeShow(params) {
  return request({
    url: '/mall-admin/productCategory/update/showStatus',
    method: 'post',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/classify.js